import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';
import { IUserService } from '../../user/user.service';
import { IUserStore, UserRole } from '../../user/user.store';
import { ChangeUserRoleModal } from '../components/ChangeUserRoleModal';

interface IProps {
  showModal: boolean;
  userId: string;
  onClose: () => void;
}

export const ChangeUserRoleContainer = observer((props: IProps): ReactElement => {
  const userService = useInjection(IUserService.$);
  const userStore = useInjection(IUserStore.$);

  const [selectedRole, setSelectedRole] = useState<UserRole>(UserRole.User);

  useEffect(() => {
    const planInfo = userStore.adminUserInfo.find((p) => p.id === props.userId);
    setSelectedRole(planInfo?.role ?? UserRole.User);
  }, [props.showModal]);

  const handleSaveRoleChange = async (): Promise<void> => {
    await userService.changeUserRoleAsync(props.userId, selectedRole);
    props.onClose();
  };

  const handleChangeSelectedRole = (role: UserRole): void => {
    setSelectedRole(role);
  };

  return (
    <ChangeUserRoleModal
      show={props.showModal}
      selectedRole={selectedRole}
      onClose={props.onClose}
      onSave={handleSaveRoleChange}
      onChange={handleChangeSelectedRole}
    />
  );
});
